import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../appUtils/axiosConfig";

const initialState = {

    isLoading: false,
    error: null,
    sizes: [],
    activesizes: [],
    isSizesLoading: false

}


export const getSizes = createAsyncThunk(
    'get_sizes_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getSizesStart());
            const response = await axios.get(`/sizes/get_size.php`)
            console.log('response of sizes', response?.data)
            if (response?.data?.status === 'success') {
                // Transform API data to UI format
                dispatch(getSizesSuccess(response?.data))
            }

            return response?.data?.data
        } catch (error) {
            dispatch(getSizesFailure(error.response.data.message))
        }
    }
)
export const getActiveSizes = createAsyncThunk(
    'get_sizes_page',
    async (_, { dispatch, rejectWithValue }) => {

        try {
            dispatch(getActiveSizesStart());
            const response = await axios.get(`/sizes/get_active_size.php`)
            console.log('response of sizes slice', response)
            if (response?.status === 200) {
                // Transform API data to UI format
                dispatch(getActiveSizesSuccess(response?.data))
            }

            return response?.data?.data
        } catch (error) {
            dispatch(getActiveSizesFailure(error.response.data.message))
        }
    }
)
export const addSize = createAsyncThunk(
    "addsizes",
    async (data, { dispatch, rejectWithValue }) => {
        const formData = new FormData();
        formData.append("title", data.title);
        formData.append("status", data.status);
        try {
            dispatch(addSizesStart());
            // Transform UI data to API format before sending
            const response = await axios.post(`/sizes/add_size.php`, data);
            dispatch(addSizesSuccess(response.data?.user));
            if (response?.data?.status === 'success') {
                dispatch(getSizes())
                // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
            }
            return response.data
        } catch (error) {
            dispatch(addSizesFailure(error.response.data.message));
            // SHOW_ERROR_NOTIFICATION(error.response.data.message);
            return rejectWithValue(error.response.data.message);
        }
    }
);
export const deleteSize = createAsyncThunk('deletesize', async (id, { dispatch, rejectWithValue }) => {
    try {
        dispatch(updateSizesStart());
        const response = await axios.delete(`/sizes/delete_size.php?id=${id}`);
        if (response?.data?.status === 'success') {
            dispatch(getSizes())
            // SHOW_SUCCESS_NOTIFICATION("Login Successfully");
        }
        return response.data
    } catch (error) {
        // SHOW_ERROR_NOTIFICATION(error.response.data.message);
        return rejectWithValue(error.response.data.message);
    }
})
export const updateSize = createAsyncThunk(
    "hsn/updateHsn",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        console.log("Updating HSN — ID:", id, "Data:", data);

        try {
            dispatch(updateSizesStart());

            // Send to API as expected (id + payload)
            const response = await axios.post(`/sizes/update_size.php`, {
                id,
                ...data,
            });

            if (response?.data?.status === "success") {
                dispatch(updateSizesSuccess(response.data?.hsn));
                dispatch(getSizes()); // refresh list
            } else {
                dispatch(updateSizesFailure(response.data.message));
                return rejectWithValue(response.data.message);
            }

            return response.data;
        } catch (error) {
            const msg = error?.response?.data?.message || "Failed to update HSN";
            dispatch(updateSizesFailure(msg));
            return rejectWithValue(msg);
        }
    }
);

const sizesSlice = createSlice({
    name: 'sizesReducer',
    initialState,
    reducers: {
        getSizesStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getSizesSuccess(state, action) {

            state.sizes = action.payload;
            state.isLoading = false;
        },
        getSizesFailure(state, action) {
            state.sizes = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        getActiveSizesStart(state) {
            state.isLoading = true;
            state.error = null;
        },
        getActiveSizesSuccess(state, action) {

            state.activesizes = action.payload;
            state.isLoading = false;
        },
        getACtiveSizesFailure(state, action) {
            state.activesizes = null;
            state.isLoading = false;
            state.error = action.payload;

        },
        addSizesStart(state) {
            state.isSizesLoading = true;
            state.error = null;
        },
        addSizesSuccess(state, action) {
            state.user = action.payload;
            state.isSizesLoading = false;
        },
        addSizesFailure(state, action) {
            state.error = action.payload;
            state.isSizesLoading = false;
        },

        updateSizesStart(state) {
            state.isSizesLoading = true;
            state.error = null;
        },
        updateSizesSuccess(state, action) {
            state.user = action.payload;
            state.isSizesLoading = false;
        },
        updateSizesFailure(state, action) {
            state.error = action.payload;
            state.isSizesLoading = false;
        },
    }
})

export const { getSizesSuccess, getSizesStart, getSizesFailure, getActiveSizesSuccess, getActiveSizesStart, getActiveSizesFailure, addSizesStart, addSizesSuccess, addSizesFailure, updateSizesStart, updateSizesSuccess, updateSizesFailure } = sizesSlice.actions;

export default sizesSlice.reducer;